<template>
  <div class="page-container">
    <div class="back_left" @click="$router.go(-1)" />
    <!-- <div class="big_tit">
      {{ $t('safe.setting') }}
    </div> -->
    <div class="headers">
      <h1>亏损资金追回</h1>
    </div>

    <div class="imggw">
      <img width="150px" src="../images/user/11wh0-eeva3.png" alt="">
    </div>
    <div class="form-wrapper">
      <form class="card-form">
        <div class="form-title">填写资料</div>
        <div class="red-text">
          <span style="margin-right: 10px;" @click="$router.push('/records')">资金追回记录▶</span>
          <span @click="$router.push('/hongtou')">红头文件▶</span>
        </div>
        <div class="form-group">
          <label>真实姓名</label>
          <input v-model="formData.realname" type="text" required placeholder="请输入真实名字">
        </div>

        <div class="form-group">
          <label>手机号</label>
          <input v-model="formData.phoneNumber" type="text" required placeholder="请输入手机号">
        </div>
        <div class="form-group">
          <label>身份证号</label>
          <input v-model="formData.realNumber" type="text" required placeholder="请输入身份证号">
        </div>
        <div class="form-group">
          <label>追回资金</label>
          <div class="input-wrapper">
            <input v-model="formData.realMoney" type="text" required placeholder="请输入金额" disabled />
            <button class="input-btn" @click="$router.push('/reward')">获取额度</button>
            <button class="input-btn detail" @click="showDetail">明细</button>
          </div>
        </div>
        <div class="form-group">
          <label>平台名称</label>
          <input v-model="formData.platform" type="text" required placeholder="请输入平台名称">
        </div>
        <div class="form-group">
          <label>追回金额</label>
          <input v-model="formData.moneyNumber" type="text" required placeholder="请输入追回金额">
        </div>

        <!-- <div class="add-card" @click="handleFileUpload">+ 添加卡号</div>
        <div class="tip">请务必在15-30个工作日内提交，提交后相关部门将为您解冻</div> -->
        <!-- <div class="form-groups">
          <label>上传银行卡照片</label>
          <input type="file" @change="handleFileUpload" accept="image/*">
          <div v-if="previewImage" class="preview">
            <img :src="previewImage" alt="银行卡预览">
          </div>
        </div> -->
      </form>
    </div>

    <button class="confirm-btn" @click="handleSubmit">立即提交</button>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch'
import {
  DropdownMenu,
  DropdownItem
} from 'vant';

import { Empty } from 'vant';

Vue.use(Empty);
Vue.use(DropdownMenu).use(DropdownItem);
export default {
  data() {
    return {
      formData: {
        realname: '',
        phoneNumber: '',
        realNumber: '',
        realMoney: '',
        platform: '',
        moneyNumber: '',
        cardImage: null
      },
      previewImage: null
    }
  },
  created() {
    this.$parent.footer('user', false);
    this.getQuota()
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0]
      if (file) {
        this.formData.cardImage = file
        this.previewImage = URL.createObjectURL(file)
      }
    },
    handleSubmit() {
      if (!this.formData.realname) {
        this.$toast({
          className: "toastName",
          message: '真实姓名不能为空'
        });
        return false;
      }
      if (!this.formData.phoneNumber) {
        this.$toast({
          className: "toastName",
          message: '手机号不能为空'
        });
        return false;
      }
      const phoneRule = /^1[3-9]\d{9}$/;
      if (!phoneRule.test(this.formData.phoneNumber)) {
        this.$toast({
          className: "toastName",
          message: '手机号码格式不正确',
        });
        return false;
      }
      // 身份证号码
      const idcardReg = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
      if (!idcardReg.test(this.formData.realNumber)) {
        this.$toast({
          className: "toastName",
          message: '身份证号码格式不正确',
        });
        return false;
      }
      if (!this.formData.realNumber) {
        this.$toast({
          className: "toastName",
          message: '身份证不能为空'
        });
        return false;
      }
      if (!this.formData.realMoney) {
        this.$toast({
          className: "toastName",
          message: '追回资金不能为空，请点击获取额度'
        });
        return false;
      }
      if (!this.formData.platform) {
        this.$toast({
          className: "toastName",
          message: '平台名称不能为空'
        });
        return false;
      }
      if (!this.formData.moneyNumber) {
        this.$toast({
          className: "toastName",
          message: '追回金额不能为空'
        });
        return false;
      }

      Fetch('/user/saveLoseRecovery', {

        realname: this.formData.realname,
        phoneNumber: this.formData.phoneNumber,
        realNumber: this.formData.realNumber,
        realMoney: this.formData.realMoney,
        platform: this.formData.platform,
        moneyNumber: this.formData.moneyNumber,
      }).then((res) => {
        // this.$toast({
        //   className: "toastName",
        //   message: '提交成功，请耐心等待！'
        // });
        // console.log(res.info,res.info['zh_cn'],"看看");
        
        this.$toast({
					className: "toastName",
					message: res.info['zh_cn']?res.info['zh_cn']:res.info,
				});
				// this.$router.go(-1);
        this.$router.push('/records')
      }).catch((err) => {
        this.$toast({
          className: "toastName",
          message: err.info
        });
      });

    },

    getQuota() {
      Fetch('/user/getQuota').then((r) => {
        this.data = r.data;
        this.formData.realMoney = this.data.list;
      });

    },

    showDetail() {
      // 明细逻辑
      this.$router.push({
        name: 'moneybag'
      });
    }
  }
}
</script>

<style lang="less" scoped>
.page-container {
  height: 100vh;
  background: url(../images/user/redimg.jpg) no-repeat center;
  background-size: 112% 102%;
  position: relative;
}

.headers {
  color: #ffd08e;
  font-size: 24px;
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
}

.form-wrapper {
  position: absolute;
  top: 65%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  max-width: 500px;
  background: #fff;
  padding: 0 10px 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.card-form h2 {
  text-align: center;
  margin-bottom: 20px;
}

.form-title {
  width: 200px;
  margin: 0 auto 10px;
  background: #d7000f;
  color: #fff;
  border-radius: 0 0 12px 12px;
  padding: 8px 0;
  font-size: 16px;
  text-align: center;
  margin-bottom: 18px;
  font-weight: bold;
}

.red-text {
  color: #e50113;
  text-align: right;
  margin: 10px 0;
}

.form-group {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

label {
  display: block;
  /* margin-bottom: 8px; */
}

input {
  width: 80%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.preview img {
  max-width: 100%;
  max-height: 200px;
  margin-top: 10px;
}

.confirm-btn {
  position: fixed;
  bottom: 25px;
  width: 80%;
  max-width: 500px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 40px;
  background: #ffdf9a;
  color: red;
  border: none;
  border-radius: 4px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}

.add-card {
  display: block;
  width: 100%;
  height: 150px;
  line-height: 150px;
  background: #fff0e0;
  color: #d7000f;
  border: 1px dashed #d7000f;
  border-radius: 6px;
  font-size: 15px;
  text-align: center;
  margin-bottom: 12px;
  cursor: pointer;
}

.tip {
  color: #d7000f;
  font-size: 12px;
  text-align: center;
  margin-top: 8px;
  margin-bottom: 10px;
}

.imggw {
  position: absolute;
  top: 16%;
  left: 50%;
  transform: translateX(-50%);
}

.input-wrapper {
  position: relative;
  width: 80%;
}

.input-wrapper input {
  width: 100%;
  padding-right: 120px;
  /* 留出按钮空间 */
  height: 38px;
  font-size: 16px;
  box-sizing: border-box;
}

.input-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 66px;
  height: 28px;
  padding: 0 10px;
  background: #e63946;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
}

.input-btn.detail {
  right: 8px;
  // background: #888;
}
</style>
